<template>
	<div>
		<TriggerEditorHeader :title="title" :icon="service.service_slug" />
		<AddOnTriggerFormDataProvider />
	</div>
</template>

<script>
import TriggerService from '@/components/FlowTree/trigger-service';
import AddOnTriggerFormDataProvider from './AddOnTriggerFormDataProvider.vue';
import ElementContextMixin from './ElementContextMixin';
import TriggerEditorHeader from './TriggerEditorHeader.vue';
import PlacementService from '@/utils/placement-service';

export default {
	name: 'AddOnTriggerEditor',
	mixins: [ElementContextMixin],
	computed: {
		itemName() {
			return this.placement.item_name;
		},
		serviceName() {
			return this.service.service_name;
		},
		addOnType() {
			return PlacementService.getAddOnType(this.placement, this.element.type);
		},
		title() {
			return TriggerService.getTriggerTitle(this.itemName, this.serviceName, this.addOnType);
		},
	},
	components: { TriggerEditorHeader, AddOnTriggerFormDataProvider },
};
</script>

<style lang="scss" scoped></style>
